<template>
  <div class="vx-row bg-white rounded-3xl w-full m-0">
    <div class="vx-col w-full pl-0">
      <vue-tabs ref="tabsContainer" v-model="activeTab">
        <v-tab key="adsets" tabKey="adsets">
          <!-- Start title -->
          <div slot="title">
            <h4 class="align-middle font-light py-3 px-5">
              {{ $t('Ad Sets') }}
            </h4>
          </div>
          <!-- End title -->

          <!-- Start content -->
          <div class="p-6 mt-2" v-if="campaign !== null && activeTab === 'adsets'">
            <AdsetsTable
              ref="AdsetsTable"
              :filters="filters"
              :pixelEvent="filters.pixelEvent"
              :editable="campaign.version == 'v3'"
              :campaignType="campaignType"
              :campaignBudgetType="campaign.end_date ? 'Budget' : 'Daily Budget'"
            />
          </div>
          <!-- End content -->
        </v-tab>

        <v-tab key="domains" v-if="showDomainTab" tabKey="domains">
          <!-- Start title -->
          <div slot="title">
            <h4 class="align-middle font-light py-3 px-5">
              {{ $t('Websites') }}
            </h4>
          </div>
          <!-- End title -->

          <!-- Start content -->
          <div class="p-6 mt-2" v-if="campaign !== null && activeTab === 'domains'">
            <DomainsTable
              ref="DomainsTable"
              :maxBidOfSelectedAdset="maxBidOfSelectedAdset"
              :filters="domainsFilters"
              :pixelEvent="filters.pixelEvent"
              :canEditBid="canEditBid"
              :campaignType="campaignType"
            />
          </div>
          <!-- End content -->
        </v-tab>

        <v-tab key="contentCategory" v-if="$hasFeature('content-categories') && showContentCategoryTab" tabKey="contentCategory">
          <!-- Start title -->
          <div slot="title">
            <h4 class="align-middle font-light py-3 px-5">
              {{ $t('Categories') }}
            </h4>
          </div>
          <!-- End title -->

          <!-- Start content categories table -->
          <div class="p-6 mt-2" v-if="campaign !== null && activeTab === 'contentCategory'">
            <ContentCategoriesTable
              ref="ContentCategory"
              :maxBidOfSelectedAdset="maxBidOfSelectedAdset"
              :filters="contentCategoryFilters"
              :pixelEvent="filters.pixelEvent"
              :canEditBid="canEditBid"
              :campaignType="campaignType"
            />
          </div>
          <!-- End content categories table -->
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>

<script>
import {
  VueTabs,
  VTab
} from '@/components/vue-nav-tabs/vue-nav-tabs.js'

import '@/components/vue-nav-tabs/nav-tabs.scss'

import AdsetsTable from '@/views/campaigns/insights/components/_content_partials/_tables_partials/AdsetsTable.vue'
import DomainsTable from '@/views/campaigns/insights/components/_content_partials/_tables_partials/DomainsTable.vue'
import ContentCategoriesTable from '@/views/campaigns/insights/components/_content_partials/_tables_partials/ContentCategoriesTable.vue'

export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  components: {
    VueTabs,
    VTab,
    AdsetsTable,
    DomainsTable,
    ContentCategoriesTable
  },
  data () {
    return {
      activeTab: null,
      campaign: null,
      domainsFilters: {},
      contentCategoryFilters: {},
      showDomainTab: true,
      showContentCategoryTab: true
    }
  },
  computed: {
    campaignType () {
      return this.campaign.display_type ? this.campaign.display_type.display_name : 'N/A'
    },
    canEditBid () {
      if (this.campaign.version === 'v3') {
        const campaignConversionsNotAllowBidEditing = [
          this.$constants.CAMPAIGN_OBJECTIVES_NAMES.CONVERSIONS,
          this.$constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM
        ]

        const typeCheck = this.campaign.display_type ? (this.campaign.display_type.display_name === this.$constants.CAMPAIGN_TYPES_NAMES.INLINE) : false
        const objectiveCheck = this.campaign.objective ? campaignConversionsNotAllowBidEditing.includes(this.campaign.objective.display_name) : false

        return !(typeCheck || objectiveCheck)
      }
      return false
    },
    maxBidOfSelectedAdset () {
      const adset = this.campaign.adsets.find(i => i.id === this.domainsFilters.adset)

      if (adset) {
        return parseFloat(adset.max_bid_price || 0.00)
      }

      return 0.00
    }
  },
  async mounted () {
    await this.fetchCampaign()
    await this.$store.dispatch('campaign/getTargetingLookups')
    const targetingLookup = await this.$store.getters['campaign/targetingLookups']

    const campaignAdvertisingChannel = targetingLookup['advertising_channels'].find(i => i.id === this.campaign.advertising_channel_id)

    if (campaignAdvertisingChannel) {
      this.showDomainTab = campaignAdvertisingChannel.supports_domains_insights
      this.showContentCategoryTab = campaignAdvertisingChannel.supports_content_category_insights
    }

    this.domainsFilters = this.contentCategoryFilters = this.filters
  },
  methods: {
    async fetchData () {
      if (this.activeTab === 'adsets' || this.activeTab === null) {
        await this.$refs.AdsetsTable.applyFilters()
      }

      if (this.activeTab === 'domains' && !!this.$refs.DomainsTable) {
        this.domainsFilters = this.filters
        await this.$refs.DomainsTable.applyFilters()
      }

      if (this.activeTab === 'contentCategory') {
        this.contentCategoryFilters = this.filters
        await this.$refs.ContentCategory.applyFilters()
      }
    },
    async fetchCampaign () {
      try {
        const response = await window.axios.get(`/campaigns/${this.$route.params.id}/simple`, {
          params: {
            from_date: this.filters.dateRange.startDate,
            to_date: this.filters.dateRange.endDate
          }
        })

        this.campaign = response.data.payload

      } catch (error) {
        alert('Error processing the request')
      }
    }
  }
}
</script>

<style lang="scss">
  .tab.active h4 {
    color: #0092d7;
  }

  [dir] .vue-tabs .nav > li > a:hover,
  [dir] .vue-tabs .nav > li > a:focus {
    background-color: transparent !important;
  }

  .tab.active h4 {
    font-weight: 500 !important;
  }
</style>
